export class MobileNavigation {
    constructor() {
        this.mobileNavigation = document.querySelector('.site-sidebar');
        this.hamburgerOpenButton = document.querySelector('.mobile-menu-toggle');
        this.hamburgerCloseButton = document.querySelector('.site-sidebar .mobile-menu-close');

        if (!this.mobileNavigation || !this.hamburgerOpenButton || !this.hamburgerCloseButton) {
            return;
        }

        this.initializeMobileNavigation();
    }

    initializeMobileNavigation = () => {
        this.hamburgerOpenButton.addEventListener('click', (event) => {
            this.toggleMobileMenu();
        });

        this.hamburgerCloseButton.addEventListener('click', (event) => {
            this.toggleMobileMenu();
        });

        document.addEventListener('click', (event) => {
            if (!this.mobileNavigation.contains(event.target) && !this.hamburgerOpenButton.contains(event.target)) {
                this.mobileNavigation.classList.remove('open');
                document.body.classList.remove('no-scroll');
            }
        });
    }

    toggleMobileMenu = () => {
        this.mobileNavigation.classList.toggle('open');
        document.body.classList.toggle('no-scroll', this.mobileNavigation.classList.contains('open'));
    }
}

export class SubmenuNavigation {
    constructor() {
        this.submenuToggleIcons = document.querySelectorAll('.site-sidebar .wp-block-navigation__submenu-icon');
        this.submenuToggleButtons = document.querySelectorAll('.site-sidebar .wp-block-navigation-submenu__toggle');
        this.itemLabels = document.querySelectorAll('.site-sidebar .wp-block-navigation-item__content .wp-block-navigation-item__label');

        if (!this.submenuToggleIcons.length || !this.submenuToggleButtons.length || !this.itemLabels.length) {
            return;
        }

        this.initializeSubmenuNavigation();
        this.initializeItemLabels();
        this.openSubmenuNavigation();
    }
    initializeSubmenuNavigation = () => {
        this.submenuToggleIcons.forEach(button => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                const buttonToggle = button.previousElementSibling;
                if (buttonToggle) {
                    const isExpanded = buttonToggle.getAttribute('aria-expanded') === 'true';
                    buttonToggle.setAttribute('aria-expanded', !isExpanded);
                }
            });
        });
    }
    openSubmenuNavigation = () => {
        const hash = window.location.hash;
        if (hash) {
            const targetElement = document.getElementById(hash.substring(1));
            if (targetElement) {
                // ensure the submenu is rendered, and set aria-expanded to true
                setTimeout(() => {
                    const parentButton = targetElement.closest('.wp-block-navigation-item').querySelector('button.wp-block-navigation-item__content');
                    if (parentButton) {
                        parentButton.setAttribute('aria-expanded', true);
                    }
                }, 100);
            }
        }
    }
    initializeItemLabels = () => {
        let labelId = 0;
        this.itemLabels.forEach(label => {
            const parentButton = label.closest('.wp-block-navigation-item').querySelector('button.wp-block-navigation-item__content');
            if (parentButton) {
                parentButton.setAttribute('id', `label-` + labelId++);
            }

            label.addEventListener('click', (event) => {
                const parentLink = label.closest('.wp-block-navigation-item').querySelector('a');
                const parentButton = label.closest('.wp-block-navigation-item').querySelector('button');
                if (parentLink) {
                    const href = parentLink.getAttribute('href');
                    const labelAttrId = parentButton ? parentButton.getAttribute('id') : null;
                    if (href) {
                        window.location.href = labelAttrId ? href + `#${labelAttrId}` : href;
                    }
                }
                event.preventDefault();
            });
        });
    }
}

